import { render, staticRenderFns } from "./tabheader.vue?vue&type=template&id=60574048&scoped=true&"
import script from "./tabheader.vue?vue&type=script&lang=js&"
export * from "./tabheader.vue?vue&type=script&lang=js&"
import style0 from "./tabheader.vue?vue&type=style&index=0&id=60574048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60574048",
  null
  
)

export default component.exports